'use client';
import { useClientConfig } from '@providers/ClientConfigProvider';
import { PageData } from './AppLayout';
import { getScripts } from './HtmlHeadScripts';
import { buildSchema } from './SchemaGenerator';

type HeadProps = {
  data?: Partial<PageData> & { _type: string };
  templates?: { title: string; url: string; imageUrl: string }[];
  posts?: { title: string; url: string; imageUrl: string }[];
  lang: string;
};
export default function HtmlHead({ data, templates, posts, lang }: HeadProps) {
  const config = useClientConfig();
  const schemas = buildSchema({
    data,
    templates,
    posts,
    lang,
    websiteDomain: config.WEBSITE_DOMAIN,
    cdnUrl: config.CDN_URL,
  });
  const scripts = getScripts(config);

  return (
    // eslint-disable-next-line next/no-head-element -- app-router root layout renders a raw <head>
    <head>
      {/* All scripts - load immediately */}
      {scripts.map((script, i) => (
        <script key={i} type="text/javascript" dangerouslySetInnerHTML={{ __html: script }} />
      ))}
      {/* Preconnect to critical external domains only */}
      <link rel="preconnect" href="https://pipedream.wistia.com" />
      <link rel="preconnect" href="https://featureassets.org" />
      {/* Critical CSS for above-the-fold content */}
      <style>
        {`
                    /* Critical styles to improve FCP */
                    body {
                        margin: 0;
                        font-family: var(--font-the-future), -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
                        -webkit-font-smoothing: antialiased;
                        -moz-osx-font-smoothing: grayscale;
                        background-color: #ffffff;
                        color: #020817;
                    }
                    
                    /* Prevent layout shift during font loading */
                    .font-loading {
                        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
                    }
                    
                    /* Critical loading states */
                    .loading {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 100vh;
                        background-color: #ffffff;
                    }
                    
                    /* Prevent FOUC */
                    .no-js {
                        display: none;
                    }
                `}
      </style>

      <script type="application/ld+json">{JSON.stringify(schemas.flat())}</script>
    </head>
  );
}
